package br.com.htms.inspeccaocampo.data

data class ErroCampo(val campo: String, val mensagem: String)

object InspecaoValidacao {
    fun validar(form: FormInspecao): List<ErroCampo> {
        val erros = mutableListOf<ErroCampo>()

        if (form.tstResponsavel.isBlank()) {
            erros += ErroCampo("tstResponsavel", "Informe o TST responsável pelo preenchimento.")
        }
        if (form.obra.isBlank()) {
            erros += ErroCampo("obra", "Selecione a obra.")
        }
        if (form.latitude == null || form.longitude == null) {
            erros += ErroCampo("localGps", "Capture o local por GPS.")
        }
        if (form.responsavelFrente.isBlank()) {
            erros += ErroCampo("responsavelFrente", "Informe o responsável pela frente da atividade.")
        }
        if (form.descricaoAtividade.isBlank()) {
            erros += ErroCampo("descricaoAtividade", "Informe a descrição da atividade.")
        }
        if (form.efetivo.isBlank()) {
            erros += ErroCampo("efetivo", "Informe o efetivo (quantidade de funcionários).")
        }

        form.itens.forEach { item ->
            when (item.resposta) {
                null -> {
                    if (item.obrigatorio) {
                        erros += ErroCampo(item.id, "Selecione Sim, Não ou N/A para \"${item.titulo}\"")
                    }
                }
                RespostaTernaria.SIM -> {
                    if (item.fotoObrigatoriaSeSim && item.fotos.isEmpty()) {
                        erros += ErroCampo(item.id, "Adicione foto para \"${item.titulo}\"")
                    }
                }
                RespostaTernaria.NAO -> {
                    if (item.justificativa.isBlank()) {
                        erros += ErroCampo(item.id, "Informe justificativa para \"${item.titulo}\"")
                    }
                    if (item.fotoObrigatoriaSeNao && item.fotos.isEmpty()) {
                        erros += ErroCampo(item.id, "Adicione foto para \"${item.titulo}\"")
                    }
                }
                RespostaTernaria.NA -> {
                    if (item.justificativa.isBlank()) {
                        erros += ErroCampo(item.id, "Informe justificativa para \"${item.titulo}\"")
                    }
                }
            }
        }

        validarSecao(
            erros,
            campo = "desvios",
            titulo = "Desvios Encontrados",
            secao = form.desviosEncontrados,
            exigirDescricaoSeSim = true,
            exigirFotoSeSim = false
        )
        validarSecao(
            erros,
            campo = "acoesCorretivas",
            titulo = "Ações Corretivas",
            secao = form.acoesCorretivas,
            exigirDescricaoSeSim = true,
            exigirFotoSeSim = true
        )

        if (form.conclusao.isBlank()) {
            erros += ErroCampo("conclusao", "Informe a conclusão.")
        }
        if (form.assinaturaSupervisor.isBlank()) {
            erros += ErroCampo("assinaturaSupervisor", "Assinatura do supervisor é obrigatória.")
        }
        if (form.assinaturaSesmt.isBlank()) {
            erros += ErroCampo("assinaturaSesmt", "Assinatura do SESMT é obrigatória.")
        }

        return erros
    }

    private fun validarSecao(
        erros: MutableList<ErroCampo>,
        campo: String,
        titulo: String,
        secao: SecaoSimNao,
        exigirDescricaoSeSim: Boolean,
        exigirFotoSeSim: Boolean
    ) {
        when (secao.resposta) {
            null -> erros += ErroCampo(campo, "Selecione Sim ou Não para \"$titulo\".")
            RespostaSimNao.SIM -> {
                if (exigirDescricaoSeSim && secao.descricao.isBlank()) {
                    erros += ErroCampo(campo, "Informe os detalhes de \"$titulo\".")
                }
                if (exigirFotoSeSim && secao.fotos.isEmpty()) {
                    erros += ErroCampo(campo, "Adicione foto para \"$titulo\".")
                }
            }
            RespostaSimNao.NAO -> Unit
        }
    }
}
